<template>
  <div class="header js_header">
    <div class="header_box">
      <img class="logo" :src="utils.setOssUrl(basicInfo.logo)" alt="" />
      <ul class="nav" v-show="mobileMore">
        <li
          :class="[
            ($route.name || '').includes('productIndex') ? 'active' : ''
          ]"
          @click="handleMenuClick('首页')"
        >
          <router-link to="/?source=header" class="nav-route">
            首 页
          </router-link>
        </li>
        <!-- <li class="user_box js_user_box">
          <div class="user_service" @click="serviceClick">
            <span>用户服务</span>
            <i class="font_family" :class="[mobileService?'icon-common_arrow_up':'icon-common_arrow_down']"></i>
          </div>
          <div class="service" v-show="mobileService" @click="handleMenuClick('常见问题')">
            <router-link to="/userService/question" v-if="basicInfo.openModule.includes(5)">常见问题</router-link>
            <a @click="manualClick">操作手册</a>
          </div>
        </li>
        <li
          v-for="item in menuOption"
          :key="item.moduleType"
          :class="[item.path.includes($route.name) ? 'active' : '']"
          @click="handleMenuClick(item.moduleName)"
        >
          <template>
            <router-link :to="item.path">{{ item.moduleName }}</router-link>
          </template>
        </li> -->
        <template v-for="(item, index) in menuOptions">
          <!-- 有二级菜单 -->
          <li
            class="user_box"
            v-if="item.children && item.children.length"
            :key="index"
            @click="handleMenuClick(item.name)"
          >
            <div class="user_service" @click="serviceClick">
              <!-- <span class="nav-route">{{ item.name }}</span> -->
              <div class="nav-box">
                <a :href="item.link" class="nav-route">{{ item.name }}</a>
                <img
                  v-if="item.imageUrl"
                  :src="utils.setOssUrl(item.imageUrl)"
                  width="33"
                  height="25"
                />
              </div>
              <i
                class="font_family"
                :class="[
                  mobileService
                    ? 'icon-common_arrow_up'
                    : 'icon-common_arrow_down'
                ]"
              ></i>
            </div>
            <div class="service" v-show="mobileService">
              <template v-for="(child, key) in item.children">
                <a
                  v-if="!Object.is(child.name, '操作手册')"
                  :key="key"
                  :href="child.link"
                  @click="handleMenuClick(child.name)"
                >
                  {{ child.name }}
                </a>
                <template v-else>
                  <a :key="key" @click="manualClick">操作手册</a>
                </template>
              </template>
            </div>
          </li>
          <!-- 无二级菜单 -->
          <li
            v-else
            :key="index"
            :class="[
              item.link.includes($route.path) &&
              !$route.name.includes('productIndex')
                ? 'active'
                : ''
            ]"
            @click="handleMenuClick(item.name)"
          >
            <a :href="item.link" class="nav-route">{{ item.name }}</a>
            <img
              v-if="item.imageUrl"
              :src="utils.setOssUrl(item.imageUrl)"
              width="33"
              height="25"
            />
          </li>
        </template>
      </ul>
      <div class="header-right">
        <dj-button type="dark" v-if="appDownloadShow" class="btn app-btn">
          下载APP
        </dj-button>
        <div
          class="download-box"
          :style="{
            left:
              freeUse && Object.is(freeUse.buttonStatus, 'y') ? '25%' : '50%'
          }"
        >
          <div
            class="item-app"
            v-for="(item, index) in navigationBarDownloadConfList"
            :key="index"
          >
            <p class="title">
              <img
                v-if="item.iconUrl"
                :src="utils.setOssUrl(item.iconUrl)"
                width="28"
                height="28"
              />
              <span>{{ item.title }}</span>
            </p>
            <p class="sub-title">{{ item.subTitle }}</p>
            <a v-if="item.link" :href="item.link" target="_blank">
              <img
                v-if="item.imageUrl"
                :src="utils.setOssUrl(item.imageUrl)"
                :alt="item.title"
                width="100"
                height="100"
              />
            </a>
            <template v-else>
              <img
                v-if="item.imageUrl"
                :src="utils.setOssUrl(item.imageUrl)"
                :alt="item.title"
                width="100"
                height="100"
              />
            </template>
          </div>
        </div>
        <dj-button
          type="light"
          v-if="freeUse && Object.is(freeUse.buttonStatus, 'y')"
          :href="freeUse.link ? freeUse.link : 'javascript:void(0)'"
          :target="freeUse.link ? '_blank' : '_self'"
          class="btn freeuse-btn"
          @click.native="handleFreeUseClick(freeUse.name)"
        >
          {{ freeUse.name || '免费试用' }}
        </dj-button>
      </div>
      <i
        class="font_family icon_more"
        :class="[mobileMore ? 'icon-nav_close' : 'icon-nav_menu']"
        @click="moreClick"
      ></i>
    </div>
    <p
      class="mask"
      v-show="mobileMore"
      @click="closeMore"
      :style="{ height: maskHeight }"
    ></p>
  </div>
</template>

<script>
import $ from 'jquery';
import { getNavigationBarInfo, getProductManual } from "@/api/common/index.js";
import utils from "@/utils/utils";
// import module from '@/const/module'
// import modulePath from '@/utils/modulePath'

export default {
  name: "layoutHeader",
  data() {
    return {
      mobileMore: false,
      mobileService: false,
      link: "",
      utils,
      menuOptions: [],
      navigationBarDownloadConfList: [],
      freeUse: {},
      maskHeight: 'initial'
    };
  },
  created() {
    this.getNavigationBarInfo();
  },
  mounted() {
    this.onResize();
    window.innerWidth > 960 && this.setAnimation();
  },
  watch: {
    basicInfo() {
      let params = {
        productId: this.basicInfo.productId
      };
      getProductManual(params).then((res) => {
        if (res.success) {
          this.link = res.data ? res.data.link : "";
        }
      });
    }
  },
  computed: {
    basicInfo() {
      return this.$store.getters.getProductBasicInfo;
    },
    // 菜单配置
    // menuOption() {
    //   const _module = Object.entries(module)
    //     .map((arr) => {
    //       const path = modulePath[arr[0]] ? modulePath[arr[0]].path : ''
    //       return {
    //         ...(arr[1] || {}),
    //         moduleKey: arr[0] || '',
    //         path
    //       }
    //     })
    //     .filter(({ isMenu, path }) => isMenu || path)
    //   const data = (this.basicInfo.openModule || [])
    //     .map((key) => {
    //       const res = _module.find(({ moduleType }) =>
    //         Object.is(moduleType, key)
    //       )
    //       return res
    //     })
    //     .filter((v) => v)
    //   return data
    // },
    // app下载配置开关
    appDownloadShow() {
      const data = this.navigationBarDownloadConfList.some((v) =>
        Object.is(v.buttonStatus, 'y')
      )
      return data
    }
  },
  methods: {
    /**
     * 获取导航栏、下载专栏、免费试用信息
     */
    getNavigationBarInfo() {
      getNavigationBarInfo().then((res) => {
        if (res.success) {
          this.menuOptions =
            res.data.navigationBarContentList
              .filter((v) => Object.is(v.buttonStatus, 'y'))
              .map((v) => {
                v.children =
                  v.children && v.children.length
                    ? v.children.filter((val) =>
                        Object.is(val.buttonStatus, 'y')
                      )
                    : v.children
                return v
              }) || []
          this.navigationBarDownloadConfList = res.data.navigationBarDownloadConfList.filter(
            (v) => Object.is(v.buttonStatus, 'y')
          )
          this.freeUse = {
            ...this.freeUse,
            ...(res.data.freeUse || {})
          }
          window.innerWidth > 960 && this.setMask();
        }
      })
    },
    /**
     * mask set
     */
    setMask() {
      const data = this.menuOptions
        .filter((v) => v.children)
        .map((v) => v.children.length)
      const max = Math.max(...data)
      this.maskHeight = `${max * 40 + 25}px`
    },
    /**
     * 菜单点击事件
     */
    handleMenuClick(name) {
      const params = {
        officialSite_e_name: name,
        officialSite_e_source: '菜单',
      };
      this.$sensors.officialSite_Router(params);
    },
    /**
     * 免费试用点击事件
     */
    handleFreeUseClick(name = '免费试用') {
      const params = {
        officialSite_e_name: name,
        officialSite_e_freeUseDetailsSource: 'nav',
        officialSite_e_productName: this.$store.getters.getProductBasicInfo.productName,
      }
      this.$sensors.officialSite_FreeUseDetails(params)
    },
    manualClick() {
      if (this.link) {
        window.open(this.link);
      } else {
        if (this.$route.path !== "/userService/manualNot") {
          this.$router.push({
            path: '/userService/manualNot'
          });
        }
      }
      this.handleMenuClick('操作手册')
    },
    setAnimation() {
      // 效果处理
      $(document.body).on('click', '.js_header .nav a', () => {
        this.mobileMore = false;
        this.mobileService = false;
        $(".js_header .mask,.js_header .service").hide();
        this.bodyFixed();
      });
      $(document.body).on('mouseenter', '.js_header .nav li.user_box, .js_header .mask', function() {
        $(".js_header .mask").show();
        $(this).find(".service").show();
        $(this).find(".user_service i").addClass("icon-common_arrow_up");
      });
      $(document.body).on('mouseleave', '.js_header .nav li.user_box, .js_header .mask', () => {
        $(".js_header .mask").hide();
        $(".js_header .service").hide();
        $(".js_header .nav li .user_service i").removeClass("icon-common_arrow_up");
      });
    },
    onResize() {
      window.onresize = () => {
        let w = $(window).width();
        if (w > 960) {
          this.mobileMore = false;
          this.mobileService = false;
          this.bodyFixed();
        }
      };
    },
    serviceClick() {
      let w = $(window).width();
      if (w < 960) {
        this.mobileService = !this.mobileService;
      }
    },
    moreClick() {
      this.mobileMore = !this.mobileMore;
      this.bodyFixed();
    },
    closeMore() {
      this.mobileMore = false;
      this.bodyFixed();
    },
    bodyFixed() {
      if (this.mobileMore) {
        $(document.body).css("position", "fixed");
      } else {
        $(document.body).removeAttr("style");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 120px;
  background-color: #FFFFFF;
  .header_box {
    width: 100%;
    height: 120px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .header-right {
      display: none;
    }
  }
  .logo {
    margin-left: 24px;
    width: 240px;
    height: 120px;
  }
  .nav {
    position: absolute;
    left: 0;
    top: 120px;
    z-index: 1000;
    padding: 32px 60px 65px;
    background: #FFFFFF;
    width: 100%;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
    li {
      font-size: 28px;
      border-bottom: 1px solid #F5F5F5;
      padding: 16px 0;
      .nav-box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        .nav-route {}
      }
      img {
        margin-left: 4px;
        width: 33px;
        height: 25px;
      }
      .user_service {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        i {
          font-size: 25px;
          color: #666666;
        }
      }
      .service {
        margin-top: 32px;
        a {
          display: block;
          font-size: 26px;
          color: #666666;
          margin-bottom: 16px;
        }
      }
    }
  }
  .icon_more {
    font-size: 48px;
    margin-right: 60px;
  }
  .mask {
    position: fixed;
    top: 120px;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #000000;
    opacity: 0.55;
    z-index: 10;
  }
}
@media (min-width: 750px) and (max-width: 960px) {
  .header {
    width: 100%;
    height: 120px;
    background-color: #FFFFFF;
    .header_box {
      width: 100%;
      height: 120px;
      background-color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }
    .logo {
      margin-left: 24px;
      width: 240px;
      height: 120px;
    }
    .nav {
      position: absolute;
      left: 0;
      top: 120px;
      z-index: 1000;
      padding: 32px 60px 65px;
      background: #FFFFFF;
      width: 100%;
      li {
        font-size: 28px;
        border-bottom: 1px solid #F5F5F5;
        padding: 16px 0;
        .user_service {
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            font-size: 25px;
            color: #666666;
          }
        }
        .service {
          margin-top: 32px;
          a {
            display: block;
            font-size: 26px;
            color: #666666;
            margin-bottom: 16px;
          }
        }
      }
      .user_box {
        margin-right: 20px;
      }
    }
    .icon_more {
      font-size: 48px;
      margin-right: 60px;
    }
    .mask {
      position: fixed;
      top: 120px;
      left: 0;
      bottom: 0;
      width: 100%;
      background: #000000;
      opacity: 0.55;
      z-index: 10;
    }
  }
}
@media (min-width: 961px) {
  .header {
    width: 100%;
    height: 72px;
    background-color: #FFFFFF;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .header_box {
      width: 1200px;
      margin: 0 auto;
      height: 72px;
      background-color: #FFFFFF;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      .header-right {
        display: flex;
        position: relative;
        .download-box {
          display: flex;
          justify-content: center;
          position: absolute;
          top: 63px;
          left: 50%;
          transform: translate(-50%, 0);
          z-index: 100;
          background-color: #fff;
          text-align: center;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s ease 0.2s, visibility 0.2s ease 0.2s;
          &:hover {
            opacity: 1;
            visibility: visible;
            transition-delay: 0s;
          }
          &:after {
            content: '';
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
            top: -7px;
            height: 0px;
            width: 0px;
            border-bottom: 8px solid #fff;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }
          .item-app {
            padding: 10px;
            margin: 10px 2px;
            min-width: 146px;
            .title {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 20px;
              color: #403c44;
            }
            .sub-title {
              margin: 10px 0 16px;
              font-size: 14px;
              color: #7f7f7f;
            }
          }
        }
        .app-btn {
          &:hover {
            & + .download-box {
              opacity: 1;
              visibility: visible;
              transition-delay: 0s;
            }
          }
        }
      }
    }
    .logo {
      margin-left: 0;
      width: 144px;
      height: 72px;
    }
    .nav {
      display: flex !important;
      align-items: center;
      flex: 1;
      height: 100%;
      position: relative;
      top: 0;
      right: 0;
      z-index: 1000;
      padding: 0;
      background: #FFFFFF;
      width: auto;
      margin: 0 50px;
      overflow: inherit;
      li {
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        padding-left: 28px;
        position: relative;
        // min-width: 84px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .user_service {
          i {
            font-size: 12px;
          }
        }
        .service {
          position: absolute;
          left: 1px;
          top: 72px;
          z-index: 10;
          margin-top: 0;
          margin-left: 32px;
          min-width: 66px;
          display: none;
          a {
            font-size: 16px;
            color: #666666;
            line-height: 21px;
            margin-top: 20px;
            cursor: pointer;
            margin-bottom: 0;
          }
        }
        &.active,
        &:hover {
          a {
            font-weight: 600;
          }
          .service {
            a {
              color: #666;
            }
          }
          .user_service {
            span {
              color: #0064EB;
            }
            i {
              color: #0064EB;
            }
          }
          .nav-route {
            &:after {
              // transform: scale(1);
              opacity: 1;
            }
          }
        }
        &:first-child {
          margin-left: 0;
        }
        a {
          position: relative;
          font-size: 16px;
          color: #333333;
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
        }
        .nav-route {
          position: relative;
          display: flex;
          align-items: center;
          height: 100%;
          white-space: nowrap;
          &:after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -6px;
            height: 15px;
            width: 30px;
            background-image: url('../../assets/images/menu_active.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            // background: #0064eb;
            transition: transform 0.2s ease-out, opacity 0.2s ease-out;
            transform-origin: 50% 0;
            // transform: scaleX(0.01);
            transform: translateX(-50%);
            opacity: 0;
          }
        }
        i {
          font-size: 12px;
          color: #333333;
          // position: absolute;
          // right: -20px;
          // top: 30px;
          margin-left: 4px;
          z-index: 6;
        }
      }
    }
    .icon_more {
      display: none;
    }
    .mask {
      position: absolute;
      top: 72px;
      left: 0;
      width: 100%;
      height: 310px;
      background: #FFF;
      display: none;
      z-index: 5;
      opacity: 1;
    }
  }
}
</style>

<style lang="scss">
@media (min-width: 961px) {
  .header {
    .header_box {
      .header-right {
        .btn {
          a.button {
            border-radius: 24px;
            width: 96px;
            height: 42px;
            font-weight: 500;
            font-size: 14px;
          }
        }
        .app-btn {
          a.button {
            background: linear-gradient(111deg, #ffca80 0%, #e3a872 69%);
          }
        }
        .freeuse-btn {
          margin-left: 14px;
          a.button {
            color: #e3a872;
            border-color: #e3a872;
            &:hover {
              background-color: #fff;
              border: 1px solid #e3a872;
            }
          }
        }
      }
    }
  }
}
</style>
